module.exports = __webpack_public_path__ + "static/media/documentToken.a4da0c39.svg";